import type { DuplicateShopSettingsDto } from "./use-duplicate-shop-settings";
import { useApiMutation } from "./use-api-mutation";

export interface DuplicateSettingsPreviewCarrier {
  code: string;
  title: string | null;
}

/** BBS-383. What a duplication would do to the target, nothing written. */
export interface DuplicateShopSettingsPreview {
  /** Sections of the target overwritten as a whole. */
  sections: string[];
  carriers?: {
    deleted: DuplicateSettingsPreviewCarrier[];
    added: DuplicateSettingsPreviewCarrier[];
    kept: DuplicateSettingsPreviewCarrier[];
    defaultCode: string | null;
  };
  overrideRules?: { before: number; after: number };
  routingLocationRules?: { before: number; after: number };
  integrations?: { removed: string[]; replaced: string[]; added: string[] };
  /** Emails invited on the target. */
  members?: string[];
}

export default function useDuplicateShopSettingsPreview(shopId: string) {
  return useApiMutation(
    "post",
    "/shops/{shopId}/duplicate-settings/preview" as never,
    {
      // The dialog reports refusals itself, with their reason.
      notify: false,
      mapVariables: (requestBody: DuplicateShopSettingsDto) => ({
        params: { path: { shopId } },
        body: requestBody,
      }),
    },
  );
}
